import React, { Component } from "react";

import "./playbook-build-page.css";

class PlaybookReasonForm extends Component {
	constructor(props) {
		super(props);
		this.state = {
			reason: "",
		};
	}

	onReasonTyped = event => {
		this.setState({ reason: event.target.value });
	};

	onSaveReason = async () => {
		const { onSave } = this.props;
		const trimmedReason = this.state.reason.trim();
		const isSaved = await onSave({ reason: trimmedReason });
		return isSaved;
	};

	render() {
		const { placeholder, saveLabel, isSaving, onCancel } = this.props;
		const { reason } = this.state;
		const isReasonGiven = reason.trim().length > 0;
		return (
			<div className="playbook-build__waiver-form">
				<input className="tk-input" value={reason} onChange={this.onReasonTyped} placeholder={placeholder} maxLength={2000} autoFocus disabled={isSaving} />
				<div className="playbook-build__waiver-actions">
					<button type="button" className="tk-button tk-button--primary tk-button--compact" onClick={this.onSaveReason} disabled={!isReasonGiven || isSaving}>
						{isSaving ? "Saving…" : saveLabel}
					</button>
					<button type="button" className="tk-text-action tk-text-action--muted" onClick={onCancel} disabled={isSaving}>
						Cancel
					</button>
				</div>
			</div>
		);
	}
}

export default PlaybookReasonForm;
